import Vue from "vue";
import Router from "vue-router";
import {
  Toast
} from "vant";
import store from "../store";
import HeaderBg from "../components/header_bg.vue";
import welcome from "../view/welcome.vue";
import policyList from "../view/policyList.vue";
import policyDetail from "../view/policyDetail.vue";
import search from "../view/search.vue";
import addlabel from "../view/addlabel.vue";
import autoMatch from "../view/autoMatch.vue";
import NotFound from "../view/NotFound.vue";

Vue.use(Router);

let router = new Router({
  // mode: 'history',
  routes: [{
      path: "/",
      redirect: "/welcome"
    },
    {
      path: "/welcome",
      name: "welcome",
      component: welcome
    },
    {
      path: "/policyList",
      name: "policyList",
      components: {
        default: policyList,
        HeaderBg: HeaderBg,
      }
    },
    {
      path: "/policyDetail/:id",
      name: "policyDetail",
      components: {
        default: policyDetail,
        HeaderBg: HeaderBg,
      }
    },
    {
      path: "/search",
      name: "search",
      components: {
        default: search,
        HeaderBg: HeaderBg,
      }
    },
    {
      path: "/addlabel",
      name: "addlabel",
      components: {
        default: addlabel,
        HeaderBg: HeaderBg,
      }
    },
    {
      path: "/autoMatch",
      name: "autoMatch",
      components: {
        default: autoMatch,
        HeaderBg: HeaderBg,
      }
    },
    {
      path: "*",
      components: {
        default: NotFound,
        HeaderBg: HeaderBg,
      }
    }
  ]
});

function delCodeandstate(to) { //去除url中的code和state
  let path = ""
  for (let i in to.query) {
    if (i != "code" && i != "state") {
      path = path + "&" + i + "=" + to.query[i]
    }
  }
  path = path == "" ? "" : path.substring(1, path.length)
  path = path == "" ? "" : "/?" + path
  return path;
}
//市民云授权登录
// router.beforeEach((to, from, next) => {
//   let fullPath = to.fullPath,
//     redirect_uri = encodeURIComponent("https://baidu.com" + fullPath),
//     clientId = "1PUZuzLcOf",
//     client_secret = "WQFKGgJJGlMX1kcV9rreHC5P8FMfgLap45TvDK1c",
//     code = to.query.code,
//     state = to.query.state
//   if (to.fullPath.includes("code")) { //判断url中是否有code，踩坑1-页面反复跳转
//     fullPath = delCodeandstate(to)
//   }
//   if (to.path == "/welcome") { //白名单内不做登录判断，直接next
//     next()
//   } else {
//     // 获取token
//     let code = to.query.code
//     if (code) {

//     }

//     // 授权获取code
//     window.location.href = `https://api.eshimin.com/api/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirect_uri}&scope=read`


//     if (code && state && !token) { //登陆之后获取到code，传到后台登录

//     } else { //未登录，没有token，去登录
//       //去登录
//       window.location.href = `https://api.eshimin.com/api/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirect_uri}&scope=read`
//     }
//   }
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js